<template>
  <div class="container" uk-form-custom="target: > * > span:first-child">
    <select @change="onChange">
      <option v-for="item in items" :key="item.value" :value="item.value">
        {{ item.label }}
      </option>
    </select>
    <button class="selector uk-button uk-button-default" type="button" tabindex="-1">
      <span></span>
      <span uk-icon="icon: chevron-down"></span>
    </button>
  </div>
</template>
<style lang="scss" scoped>
.container {
  width: 100%;
}
.selector {
  width: 100%;
  display: flex;
  align-items: center;
  border: 0;
  span:first-child {
    flex: 1;
    text-align: left;
  }
  span:nth-child(2) {
    margin-left: $spacing-small;
  }
}
</style>

<script lang="ts">
import { Vue } from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator";
import { LabelAndValue } from "../../types";
export default class DropdownButton extends Vue {
  @Prop() readonly items: LabelAndValue[] = [];
  @Emit("select")
  onChange(event: Event) {
    if (!event.target) return;
    return this.items.find(item => item.value === (event.target as HTMLSelectElement).value);
  }
}
</script>
